import { createDataHook } from 'next-data-hooks';
import sdk from '../../../lib/sdk';

const useBackgroundImage = createDataHook('BackgroundImage', async () => {
  const mainImage = await sdk.mainImageUrl();
  return mainImage.allHomepage[0].desktopImage?.asset?.url ?? '';
});

export default useBackgroundImage;
